import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';
import { LeaderboardMultiplier } from '@/types/leaderboard.types';
import { LeaderboardActionPointState } from './types';
import { LoadActionCustomPoint } from '@/connection/leaderboard';

export const reducers = (create: ReducerCreators<LeaderboardActionPointState>) => ({
  loadActionPoints: create.asyncThunk(
    async (data: { channel: number; eventId: number }, { rejectWithValue }) => {
      try {
        return await LoadActionCustomPoint(data.channel, data.eventId);
      } catch (error) {
        return rejectWithValue(error);
      }
    },
    {
      pending: (state) => {
        state.loadingActions = true;
      },
      rejected: (state) => {
        state.fetchingError = true;
      },
      fulfilled: (state, action) => {
        state.mainActionsOn = action.payload;
        state.loadingActions = false;
      },
    }
  ),
  updateActionPoints: create.reducer((state, action: PayloadAction<LeaderboardMultiplier[]>) => {
    state.mainActionsOn = action.payload;
  }),
});
